import React from 'react'

export const handleAPIErrors = (response) => {
    if (response) {
        if (response.data.Message) {
            return response.data.Message;
        }
        else if (response.data.message) {
            return response.data.message;
        }
        else if (response.status) {
            if (response.status === 200 && response.data.fail && response.data.fail.length > 0 && response.data.details) {
                let message = (
                    <React.Fragment>
                        {parseMultiFailureMessage(response.data.details)}
                    </React.Fragment>
                )
                return message
            }
            if (response.status === 500) {
                return 'Internal server error. Please contact a system administrator.';
            }
            return undefined
        }
        else {
            return 'An error occured while trying to load the schedule. Please try refreshing the page.'
        }
    }
    else {
        return 'An error occured. Please contact a system administrator.'
    }
}

const parseMultiFailureMessage = (details, max = 5) => {
    if (details.length > max - 1) {
        return 'Multiple shifts are in conflicts'
    }

    let messages = new Map();
    for (const detail of details) {
        let msg = messages.get(detail.message.trim());

        if(msg === undefined || msg === null ){
            messages.set(detail.message.trim(), 1);
        }else{
            messages.set(detail.message.trim(), ++msg );
        }
    }

    let retour = [];
    for(const [errMsg, value] of messages){
        if (retour.length > max) {
            break;
        }

        if(value > 1){
            retour.push(
                <React.Fragment>
                    {"("+value+"x) "+errMsg}
                    {(max - 1 !== retour.length) ? <br /> : null}
                </React.Fragment>
            )
        }else{
            retour.push(
                <React.Fragment>
                    {errMsg}
                    {(max - 1 !== retour.length) ? <br /> : null}
                </React.Fragment>
            )
        }
    }

    return retour
}